
import { useState, createContext, useContext, useEffect, useCallback } from 'react'

import {
    Balance
} from '../chain'

import {useEthers} from '../ethers'
// import {
//     DEFAULT_ACCOUNT
// } from '../ethers/e'

export const Context = createContext({})

export const useBalance = () => useContext(Context)



function useBalanceProvider() {
    const {account, getBlockNumber} = useEthers()
    const blockNumber = getBlockNumber()
    const [state, setState] = useState({ account, data: Balance.Type })
    const [refreshVersion, setRefreshVersion] = useState(0)
    const refresh = useCallback(() => setRefreshVersion(version => version + 1), [])
    // console.log(account, getBlockNumber())
    useEffect(() => {
        let cancelled = false
        const call = async () => {
            try {
                const next = await Balance(account)
                if (!cancelled) setState({ account, data: next })
            } catch {
                // 保留上次余额，等待新区块或主动刷新重试；不输出原始 RPC 异常。
            }
        }
        call()
        return () => { cancelled = true }
    }, [account, blockNumber, refreshVersion])
    return { ...(state.account === account ? state.data : Balance.Type), refresh }
}

function BalanceContext({children}) {
    const p = useBalanceProvider()
    return (
        <Context.Provider
            value={p}
        >
            {children}
        </Context.Provider>
    )
}

export default BalanceContext
